import { hasPropertyCheck } from './hasPropertyCheck';

export const removeExcludedField = (inputs, exclusion) => {
  const modifiedInputs = inputs;

  for (const [index, object] of modifiedInputs.entries()) {
    if (hasPropertyCheck(object, 'name')) {
      if (exclusion.includes(object.name)) {
        modifiedInputs.splice(index, 1);
      }
    }
  }

  return modifiedInputs;
};
